"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'register.company.checkbox_label': 'Zarejestruj się z firmą',
    'register.company.form_title': 'Informacje o firmie',
    'register.company.section_title': 'Informacje o firmie (Opcjonalne)',
    'register.company.add_button': 'Dodaj firmę',
    'register.company.data_added': 'Dane firmy zostały pomyślnie dodane',
    'register.company.remove_button': 'Usuń firmę',
    'register.company.optional_help': 'Możesz opcjonalnie dodać informacje o swojej firmie podczas rejestracji',
    'register.company.removed': 'Dane firmy zostały pomyślnie usunięte',
};
